/**
 * Adiciona ao array a propriedade orderList de acordo com a ordem específicada
 * @param list
 * @param order
 */
const ordenation = (list = [], order) => {
  return list.map((item, index) => {

    if (!order[index]) {
      item.orderList = null;
      return item;
    }

    item.orderList = order[index];
    return item;
  })

}

export function ordenationLetter(list) {
  const order = [
    "a)", "b)", "c)", "d)", "e)", "f)", "g)", "h)", "i)"
  ];
  return ordenation(list, order)
}

const Ordenation = {
  ordenationLetter,
}

export default Ordenation;


// WEBPACK FOOTER //
// ./src/utils/ordenation.js